import { FC } from 'react';
import { ChevronArrowRightIcon } from 'assets/icons';
import { DisputeZone } from '../disputeVisibility.model';
import { toDisputeZone } from '../utils';

const ZONE_CLASS_NAME: Record<DisputeZone, string> = {
  green: 'bg-[#27AE601A] text-successHighlight',
  amber: 'bg-[#F7E2C033] text-pending-orange',
  red: 'bg-[#D959451A] text-error',
  grey: 'bg-[#F2F2F2] text-accentText'
};

const ZONE_TEXT_CLASS_NAME: Record<DisputeZone, string> = {
  green: 'text-successHighlight',
  amber: 'text-pending-orange',
  red: 'text-error',
  grey: 'text-accentText'
};

interface DisputeZoneChipProps {
  text: string;
  zone?: string | null;
  isLarge?: boolean;
  isPlain?: boolean;
}

export const DisputeZoneChip: FC<DisputeZoneChipProps> = ({ text, zone, isLarge = false, isPlain = false }) => {
  if (!text) return null;

  if (isPlain) {
    return <span className={`font-semibold ${ZONE_TEXT_CLASS_NAME[toDisputeZone(zone)]}`}>{text}</span>;
  }

  const chipClassName = isLarge ? 'px-2.5 py-1 text-xl font-bold' : 'px-2 py-0.5 text-px13 font-semibold';

  return <span className={`inline-flex rounded ${chipClassName} ${ZONE_CLASS_NAME[toDisputeZone(zone)]}`}>{text}</span>;
};

interface DisputeCountPillProps {
  count: number;
  isTappable: boolean;
}

export const DisputeCountPill: FC<DisputeCountPillProps> = ({ count, isTappable }) => {
  const pillClassName = isTappable ? 'bg-[#E8F2FF] text-secondary' : 'bg-[#F2F2F2] text-accentText';

  return (
    <span
      className={`inline-flex min-w-[28px] justify-center rounded px-2 py-0.5 text-px13 font-semibold
      ${pillClassName}`}>
      {count}
    </span>
  );
};

export const DisputeChevron: FC = () => <ChevronArrowRightIcon className="h-3 w-3 shrink-0" aria-hidden="true" />;
